import { APIClient } from "../api/ApiClient";
import {
  CommonDataItem,
  CommonDataResponse,
  FundNamesItem,
  DistinctFundsRequest,
} from "../../types/CommonDataRequestTypes";

import { Status } from "../../enums/Status";
import { API_ROUTES } from "../api/config";
import { MESSAGES } from "../../messages";
import { CompassError } from "../../types/errorTypes";

export const getFundNames = async (
  params: CommonDataItem<DistinctFundsRequest>,
  authToken: string
): Promise<CommonDataResponse<FundNamesItem[]>> => {
  const api = new APIClient();

  const customConfig = {
    headers: {
      token: authToken,
    },
  };

  try {
    const fundNamesResponse: CommonDataResponse<FundNamesItem[]> =
      await api.post<
        CommonDataResponse<FundNamesItem[]>,
        CommonDataItem<DistinctFundsRequest>
      >(API_ROUTES.GET_COMMON_DATA, params, customConfig);

    const fundNames: FundNamesItem[] = fundNamesResponse.data || [];

    return {
      status: Status.SUCCESS,
      message: MESSAGES.GET_FUND_NAMES_SUCCESS,
      data: fundNames,
    };
  } catch (error) {
    console.error("Failed to retrieve fund names:", error);
    return {
      status: Status.ERROR,
      message: MESSAGES.GET_FUND_NAMES_ERROR,
      error: error as CompassError,
    };
  }
};
